import React, { Component } from 'react';
import styled from 'styled-components';
import { ErrorBanner } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import { connect } from 'react-redux';
import ReactModalFooter from '../../Modal/ReactModalFooter';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import { modalActions, addAccountActions, accountActions, chartsActions } from '../../../redux/root-action';
import AddAccountBaseFields from './AddAccountBaseFields';
import AddAccountInvestmentMix from './AddAccountInvestmentMix';
import { accountModalViews, postActions, accountTypeCodes, analyticsTracking } from '../../../utils/constants';
import {
  isWithinAllowedRange,
  getIntegerAmount,
  getAge,
  isValidAccountName,
  isEligbleForERContribution,
  isEligbleForEEContribution,
} from '../../../utils/helpers';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';

const StyledIntroLine = styled.div`
  font-size: 20px;
  margin-top: 32px;
  font-family: Nimbus Sans Regular;
  @media only screen and (max-width: 767px) {
    font-size: 16px;
    margin-top: 24px;
  }
`;

const StyledText = styled.div`
  font-family: Nimbus Sans Bold;
  margin: 8px 0px 8px 0px;
  @media only screen and (max-width: 767px) {
    margin: 8px 0px 16px 0px;
  }
`;
const LegalText = styled.div`
  margin-top: 40px;
  font-size: 16px;
  font-style: italic;
  line-height: 22px;
  color: ${tokens.ColorGrey600};
`;

class AddAccountModal extends Component<any, any> {
  componentDidMount() {
    const {
      updateSelectedAccount,
      accountTypes,
      account: { selectedAccount },
    } = this.props;
    updateSelectedAccount({
      annualSavingsEE: selectedAccount.annualSavingsEE,
      annualSavingsER: selectedAccount.annualSavingsER,
      selectedAccountType: accountTypes.find(
        (accountType: any) => accountType.value === selectedAccount.overrideAccountTypeCode,
      ),
      error: {
        accountType: selectedAccount.hasYodleeAccountTypeError ? 'Please select an account type.' : '',
        assetAllocation: selectedAccount.hasYodleeAssetAllocationError ? 'Total allocation <br>must equal<br>100%' : '',
      },
      showGlobalError: false,
    });
  }
  isValid = () => {
    const {
      overrideAccountTypeCode,
      name,
      balance,
      annualSavingsEE,
      annualSavingsER,
      accountHolder,
      assetAllocation,
      amount,
      startNumber,
      isYodleeAccount,
      contributionType,
    } = this.props.account.selectedAccount;
    const {
      updateSelectedAccount,
      account: { selectedAccount, accountHolderOptions },
      riScenario: { participantProfile, spouseProfile },
    } = this.props;
    let showGlobalError = false;

    const error = {
      accountType: '',
      name: '',
      balance: '',
      annualSavingsEE: '',
      annualSavingsER: '',
      accountHolder: '',
      assetAllocation: '',
      amount: '',
      startNumber: '',
    };
    if (
      !overrideAccountTypeCode ||
      overrideAccountTypeCode === accountTypeCodes.UNKN ||
      overrideAccountTypeCode === accountTypeCodes.NS
    ) {
      error['accountType'] = 'Select account type.';
      showGlobalError = true;
    } else {
      error['accountType'] = '';
    }
    if (!isYodleeAccount && !name) {
      error['name'] = 'This field is required.';
      showGlobalError = true;
    }
    if (!isYodleeAccount && !isValidAccountName(name)) {
      error['name'] = `Account name can only include letters, numbers, and the following characters: ' - , . `;
      showGlobalError = true;
    }
    if (!isYodleeAccount && !isWithinAllowedRange(getIntegerAmount(balance), 1, 999999999)) {
      error['balance'] = 'Balance must be $1 - $999,999,999.';
      showGlobalError = true;
    }
    if (
      !isYodleeAccount &&
      isEligbleForEEContribution(contributionType) &&
      !isWithinAllowedRange(getIntegerAmount(annualSavingsEE), 0, 999999999)
    ) {
      error['annualSavingsEE'] = 'Annual Savings must be $0 - $999,999,999.';
      showGlobalError = true;
    }
    if (
      !isYodleeAccount &&
      isEligbleForERContribution(contributionType) &&
      !isWithinAllowedRange(getIntegerAmount(annualSavingsER), 0, 999999999)
    ) {
      error['annualSavingsER'] = 'Annual Savings must be $0 - $999,999,999.';
      showGlobalError = true;
    }
    if (!accountHolder) {
      error['accountHolder'] = 'This field is required.';
      showGlobalError = true;
    }
    const totalAssetAllocationPercent: any = assetAllocation
      ? Object.values(assetAllocation).reduce((a: any, c: any) => a + Number(c), 0)
      : null;
    if (totalAssetAllocationPercent < 100) {
      showGlobalError = true;
      error['assetAllocation'] = 'Total allocation <br>must equal<br>100%';
    } else if (totalAssetAllocationPercent > 100) {
      showGlobalError = true;
      error['assetAllocation'] = 'Total exceeds<br>100%';
    } else {
      error['assetAllocation'] = '';
    }
    updateSelectedAccount({
      error: { ...selectedAccount.error, ...error },
      showGlobalError,
    });

    return !showGlobalError;
  };

  handleSave = () => {
    const {
      updateAccountsData,
      setCurrentView,
      account: {
        accountHolderOptions,
        selectedAccount,
        tempScenario: { accounts },
      },
    } = this.props;
    const tempAccounts = [...accounts];
    const {
      selectedAccountType,
      accountIndex,
      action,
      assetAllocation,
      amount,
      balance,
      isYodleeAccount,
      displayType,
      annualSavingsEE,
      annualSavingsER,
      accountHolder,
      bpId,
    } = selectedAccount;
    if (this.isValid()) {
      tempAccounts[accountIndex] = {
        ...selectedAccount,
        assetAllocation: assetAllocation ? assetAllocation : null,
        amount: amount ? getIntegerAmount(amount) : 0,
        balance: balance ? getIntegerAmount(balance) : 0,
        displayType: selectedAccountType.name,
        action: action ? action : postActions.UPDATE,
        annualSavingsEE: annualSavingsEE ? getIntegerAmount(annualSavingsEE) : 0,
        annualSavingsER: annualSavingsER ? getIntegerAmount(annualSavingsER) : 0,
        bpId: accountHolderOptions.find((option: any) => option.name === accountHolder)
          ? accountHolderOptions.find((option: any) => option.name === accountHolder).value
          : bpId,
      };

      if (isYodleeAccount) {
        tempAccounts[accountIndex] = {
          ...tempAccounts[accountIndex],
          hasYodleeError: false,
          hasYodleeAssetAllocationError: false,
          hasYodleeAccountTypeError: false,
          isOverriddenYodleeAccount: true,
        };
      }

      updateAccountsData({ accounts: tempAccounts });
      setCurrentView(accountModalViews.YOUR_ACCOUNTS);
    }
  };

  handleCancelClick = () => {
    const {
      updateAccountsData,
      setCurrentView,
      account: {
        selectedAccount,
        tempScenario: { accounts },
      },
    } = this.props;

    if (selectedAccount.action === postActions.ADD) {
      accounts.splice(selectedAccount.accountIndex, 1);
    }
    updateAccountsData({ accounts });
    setCurrentView(accountModalViews.YOUR_ACCOUNTS);
  };

  render(): JSX.Element {
    const { showGlobalError, hasYodleeError } = this.props.account.selectedAccount;
    const mq = window.matchMedia('(max-width: 767px)');

    return (
      <React.Fragment>
        <ReactModalHeader
          modalTitle="Account Information"
          showClose={true}
          errorMessage={showGlobalError && 'There seem to be one or more errors. Please check your information.'}
          handleCloseIconClick={this.handleCancelClick}
        />
        <ReactModalContent showGlobalError={showGlobalError}>
          {hasYodleeError && !showGlobalError && (
            <ErrorBanner message={'There are one or more errors. Please provide the missing information.'} />
          )}
          <StyledIntroLine tabIndex={0}>
            Once you add an account, it will be included in all your retirement savings balances and projections
            throughout the site. Please review your information regularly to make sure it’s up to date.
          </StyledIntroLine>
          <StyledText tabIndex={0}> All fields are required.</StyledText>
          <div style={{ width: mq.matches ? '100%' : 440 }}>
            <AddAccountBaseFields />
            <AddAccountInvestmentMix />
          </div>
          <LegalText>
            If total annual savings across all accounts is greater than your actual salary, our projections will limit
            your contributions to your salary.
          </LegalText>
        </ReactModalContent>
        <ReactModalFooter
          CTAButtonText="Save"
          handleCTAClick={this.handleSave}
          handleCancelClick={this.handleCancelClick}
          CTAButtonId={analyticsTracking.RIXYourAccountModalEditSave}
          CancelButtonId={analyticsTracking.RIXYourAccountModalEditCancel}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  accountFields: state.addAccount,
  account: state.account,
  riScenario: state.riScenario,
  accountTypes: state.accountTypes.data,
});

export default connect(mapStateToProps, {
  hideModal: modalActions.hideModal,
  updateField: addAccountActions.updateField,
  setCurrentView: accountActions.setCurrentView,
  cleanup: accountActions.cleanup,
  postSimulation: chartsActions.postSimulation,
  updateAccountsData: accountActions.updateAccountsData,
  updateSelectedAccount: accountActions.updateSelectedAccount,
})(AddAccountModal);
